// Lib
import { PI_POST_ICONS } from '@/lib/posts/postIcon';
// Types
import type { PIPostTypesType } from '@/lib/posts/postTypes';
import { getPostType, PI_POST_TYPES } from '@/lib/posts/postTypes';
import { PINTEREST } from '@/lib/socialProfile';

// Components
import Post from '@/components/base/Post';
import { AlbumPostIcon } from '@/components/pages/albums/AlbumFunnelModal/ModalSteps/ManualStep/components/post/AlbumPostIcon';

type PinterestAlbumPostProps = {
    data: {
        type: PIPostTypesType;
    };
    shouldDisplayIcon: boolean;
};

const PinterestAlbumPost = ({ data, shouldDisplayIcon }: PinterestAlbumPostProps) => {
    const type = getPostType({ network: PINTEREST, type: data?.type });

    return (
        <Post data={data} className="w-full">
            <Post.Content className="relative w-full">
                <AlbumPostIcon
                    show={type && type !== PI_POST_TYPES.TYPE_IMAGE && shouldDisplayIcon}
                    type={PI_POST_ICONS[type]}
                />
                <div className="square relative">
                    <Post.Image />
                </div>
            </Post.Content>
        </Post>
    );
};

export default PinterestAlbumPost;
